var map = {
	"./assignments/en/MolarityDensity/dilution/assignment.json": 18789,
	"./assignments/en/MolarityDensity/dilution/configuration.json": 70934,
	"./assignments/en/MolarityDensity/dilution/reactions.json": 58392,
	"./assignments/en/MolarityDensity/dilution/solutions.json": 33388,
	"./assignments/en/MolarityDensity/dilution/species.json": 65722,
	"./assignments/en/MolarityDensity/dilution/spectra.json": 22732,
	"./assignments/en/MolarityDensity/sucrose/assignment.json": 46127,
	"./assignments/en/MolarityDensity/sucrose/configuration.json": 85760,
	"./assignments/en/MolarityDensity/sucrose/reactions.json": 45542,
	"./assignments/en/MolarityDensity/sucrose/solutions.json": 60458,
	"./assignments/en/MolarityDensity/sucrose/species.json": 3568,
	"./assignments/en/MolarityDensity/sucrose/spectra.json": 46962,
	"./assignments/en/Redox/redox/assignment.json": 87288,
	"./assignments/en/Redox/redox/configuration.json": 68285,
	"./assignments/en/Redox/redox/reactions.json": 93483,
	"./assignments/en/Redox/redox/solutions.json": 41199,
	"./assignments/en/Redox/redox/species.json": 44493,
	"./assignments/en/Redox/redox/spectra.json": 63303,
	"./assignments/en/Redox/redox2/assignment.json": 66062,
	"./assignments/en/Redox/redox2/configuration.json": 41203,
	"./assignments/en/Redox/redox2/reactions.json": 10373,
	"./assignments/en/Redox/redox2/solutions.json": 85601,
	"./assignments/en/Redox/redox2/species.json": 54447,
	"./assignments/en/Redox/redox2/spectra.json": 96553,
	"./assignments/en/chem207/exp01/assignment.json": 91092,
	"./assignments/en/chem207/exp01/configuration.json": 92673,
	"./assignments/en/chem207/exp01/reactions.json": 89055,
	"./assignments/en/chem207/exp01/solutions.json": 68739,
	"./assignments/en/chem207/exp01/species.json": 69905,
	"./assignments/en/chem207/exp01/spectra.json": 33819,
	"./assignments/en/chemvlab/IV/IV_dilute_saline/assignment.json": 41388,
	"./assignments/en/chemvlab/IV/IV_dilute_saline/configuration.json": 14921,
	"./assignments/en/chemvlab/IV/IV_dilute_saline/reactions.json": 27799,
	"./assignments/en/chemvlab/IV/IV_dilute_saline/solutions.json": 45595,
	"./assignments/en/chemvlab/IV/IV_dilute_saline/species.json": 40969,
	"./assignments/en/chemvlab/IV/IV_dilute_saline/spectra.json": 89379,
	"./assignments/en/chemvlab/IV/IV_iodine_12/assignment.json": 61514,
	"./assignments/en/chemvlab/IV/IV_iodine_12/configuration.json": 50567,
	"./assignments/en/chemvlab/IV/IV_iodine_12/reactions.json": 89705,
	"./assignments/en/chemvlab/IV/IV_iodine_12/solutions.json": 71093,
	"./assignments/en/chemvlab/IV/IV_iodine_12/species.json": 88643,
	"./assignments/en/chemvlab/IV/IV_iodine_12/spectra.json": 66909,
	"./assignments/en/chemvlab/IV/IV_iodine_18/assignment.json": 36244,
	"./assignments/en/chemvlab/IV/IV_iodine_18/configuration.json": 19585,
	"./assignments/en/chemvlab/IV/IV_iodine_18/reactions.json": 56479,
	"./assignments/en/chemvlab/IV/IV_iodine_18/solutions.json": 53443,
	"./assignments/en/chemvlab/IV/IV_iodine_18/species.json": 13905,
	"./assignments/en/chemvlab/IV/IV_iodine_18/spectra.json": 23611,
	"./assignments/en/chemvlab/IV/IV_make_glucose/assignment.json": 94277,
	"./assignments/en/chemvlab/IV/IV_make_glucose/configuration.json": 33334,
	"./assignments/en/chemvlab/IV/IV_make_glucose/reactions.json": 68376,
	"./assignments/en/chemvlab/IV/IV_make_glucose/solutions.json": 32556,
	"./assignments/en/chemvlab/IV/IV_make_glucose/species.json": 72122,
	"./assignments/en/chemvlab/IV/IV_make_glucose/spectra.json": 13964,
	"./assignments/en/chemvlab/IV/IV_make_glucose2/assignment.json": 64421,
	"./assignments/en/chemvlab/IV/IV_make_glucose2/configuration.json": 25750,
	"./assignments/en/chemvlab/IV/IV_make_glucose2/reactions.json": 31864,
	"./assignments/en/chemvlab/IV/IV_make_glucose2/solutions.json": 75212,
	"./assignments/en/chemvlab/IV/IV_make_glucose2/species.json": 52026,
	"./assignments/en/chemvlab/IV/IV_make_glucose2/spectra.json": 71980,
	"./assignments/en/chemvlab/IV/IV_make_saline/assignment.json": 16273,
	"./assignments/en/chemvlab/IV/IV_make_saline/configuration.json": 58282,
	"./assignments/en/chemvlab/IV/IV_make_saline/reactions.json": 98124,
	"./assignments/en/chemvlab/IV/IV_make_saline/solutions.json": 92128,
	"./assignments/en/chemvlab/IV/IV_make_saline/species.json": 69502,
	"./assignments/en/chemvlab/IV/IV_make_saline/spectra.json": 68768,
	"./assignments/en/chemvlab/stoichiometry/Activity1_a/assignment.json": 79206,
	"./assignments/en/chemvlab/stoichiometry/Activity1_a/configuration.json": 78171,
	"./assignments/en/chemvlab/stoichiometry/Activity1_a/reactions.json": 24797,
	"./assignments/en/chemvlab/stoichiometry/Activity1_a/solutions.json": 39513,
	"./assignments/en/chemvlab/stoichiometry/Activity1_a/species.json": 43559,
	"./assignments/en/chemvlab/stoichiometry/Activity1_a/spectra.json": 12369,
	"./assignments/en/chemvlab/stoichiometry/Activity1_b/assignment.json": 60313,
	"./assignments/en/chemvlab/stoichiometry/Activity1_b/configuration.json": 70594,
	"./assignments/en/chemvlab/stoichiometry/Activity1_b/reactions.json": 44756,
	"./assignments/en/chemvlab/stoichiometry/Activity1_b/solutions.json": 76232,
	"./assignments/en/chemvlab/stoichiometry/Activity1_b/species.json": 24710,
	"./assignments/en/chemvlab/stoichiometry/Activity1_b/spectra.json": 42936,
	"./assignments/en/chemvlab/stoichiometry/Activity2_a/assignment.json": 22245,
	"./assignments/en/chemvlab/stoichiometry/Activity2_a/configuration.json": 28150,
	"./assignments/en/chemvlab/stoichiometry/Activity2_a/reactions.json": 48728,
	"./assignments/en/chemvlab/stoichiometry/Activity2_a/solutions.json": 92076,
	"./assignments/en/chemvlab/stoichiometry/Activity2_a/species.json": 55386,
	"./assignments/en/chemvlab/stoichiometry/Activity2_a/spectra.json": 91692,
	"./assignments/en/chemvlab/stoichiometry/Activity2_b/assignment.json": 89010,
	"./assignments/en/chemvlab/stoichiometry/Activity2_b/configuration.json": 36095,
	"./assignments/en/chemvlab/stoichiometry/Activity2_b/reactions.json": 91729,
	"./assignments/en/chemvlab/stoichiometry/Activity2_b/solutions.json": 61469,
	"./assignments/en/chemvlab/stoichiometry/Activity2_b/species.json": 93931,
	"./assignments/en/chemvlab/stoichiometry/Activity2_b/spectra.json": 10965,
	"./assignments/en/chemvlab/stoichiometry/Activity2_c/assignment.json": 51523,
	"./assignments/en/chemvlab/stoichiometry/Activity2_c/configuration.json": 73036,
	"./assignments/en/chemvlab/stoichiometry/Activity2_c/reactions.json": 29858,
	"./assignments/en/chemvlab/stoichiometry/Activity2_c/solutions.json": 86038,
	"./assignments/en/chemvlab/stoichiometry/Activity2_c/species.json": 19308,
	"./assignments/en/chemvlab/stoichiometry/Activity2_c/spectra.json": 74110,
	"./assignments/en/chemvlab/stoichiometry/Activity3_a/assignment.json": 716,
	"./assignments/en/chemvlab/stoichiometry/Activity3_a/configuration.json": 95241,
	"./assignments/en/chemvlab/stoichiometry/Activity3_a/reactions.json": 2647,
	"./assignments/en/chemvlab/stoichiometry/Activity3_a/solutions.json": 20443,
	"./assignments/en/chemvlab/stoichiometry/Activity3_a/species.json": 10857,
	"./assignments/en/chemvlab/stoichiometry/Activity3_a/spectra.json": 59267,
	"./assignments/en/chemvlab/stoichiometry/Activity3_b/assignment.json": 83163,
	"./assignments/en/chemvlab/stoichiometry/Activity3_b/configuration.json": 18292,
	"./assignments/en/chemvlab/stoichiometry/Activity3_b/reactions.json": 63866,
	"./assignments/en/chemvlab/stoichiometry/Activity3_b/solutions.json": 59310,
	"./assignments/en/chemvlab/stoichiometry/Activity3_b/species.json": 72612,
	"./assignments/en/chemvlab/stoichiometry/Activity3_b/spectra.json": 39078,
	"./assignments/en/chemvlab/stoichiometry/Activity3_c/assignment.json": 20746,
	"./assignments/en/chemvlab/stoichiometry/Activity3_c/configuration.json": 17959,
	"./assignments/en/chemvlab/stoichiometry/Activity3_c/reactions.json": 5129,
	"./assignments/en/chemvlab/stoichiometry/Activity3_c/solutions.json": 65685,
	"./assignments/en/chemvlab/stoichiometry/Activity3_c/species.json": 59971,
	"./assignments/en/chemvlab/stoichiometry/Activity3_c/spectra.json": 26109,
	"./assignments/en/chemvlab/stoichiometry/Activity3_d/assignment.json": 18081,
	"./assignments/en/chemvlab/stoichiometry/Activity3_d/configuration.json": 2778,
	"./assignments/en/chemvlab/stoichiometry/Activity3_d/reactions.json": 80508,
	"./assignments/en/chemvlab/stoichiometry/Activity3_d/solutions.json": 22352,
	"./assignments/en/chemvlab/stoichiometry/Activity3_d/species.json": 10574,
	"./assignments/en/chemvlab/stoichiometry/Activity3_d/spectra.json": 31760,
	"./assignments/en/chemvlab/stoichiometry/Activity3_e/assignment.json": 60096,
	"./assignments/en/chemvlab/stoichiometry/Activity3_e/configuration.json": 79381,
	"./assignments/en/chemvlab/stoichiometry/Activity3_e/reactions.json": 1587,
	"./assignments/en/chemvlab/stoichiometry/Activity3_e/solutions.json": 5783,
	"./assignments/en/chemvlab/stoichiometry/Activity3_e/species.json": 149,
	"./assignments/en/chemvlab/stoichiometry/Activity3_e/spectra.json": 71647,
	"./assignments/en/chemvlab/stoichiometry/Activity4_a/assignment.json": 14835,
	"./assignments/en/chemvlab/stoichiometry/Activity4_a/configuration.json": 13692,
	"./assignments/en/chemvlab/stoichiometry/Activity4_a/reactions.json": 53202,
	"./assignments/en/chemvlab/stoichiometry/Activity4_a/solutions.json": 30918,
	"./assignments/en/chemvlab/stoichiometry/Activity4_a/species.json": 52892,
	"./assignments/en/chemvlab/stoichiometry/Activity4_a/spectra.json": 6766,
	"./assignments/en/chemvlab/stoichiometry/Activity4_b/assignment.json": 33060,
	"./assignments/en/chemvlab/stoichiometry/Activity4_b/configuration.json": 28945,
	"./assignments/en/chemvlab/stoichiometry/Activity4_b/reactions.json": 30127,
	"./assignments/en/chemvlab/stoichiometry/Activity4_b/solutions.json": 76627,
	"./assignments/en/chemvlab/stoichiometry/Activity4_b/species.json": 86369,
	"./assignments/en/chemvlab/stoichiometry/Activity4_b/spectra.json": 95499,
	"./assignments/en/chemvlab/stoichiometry/Activity4_c/assignment.json": 58741,
	"./assignments/en/chemvlab/stoichiometry/Activity4_c/configuration.json": 26310,
	"./assignments/en/chemvlab/stoichiometry/Activity4_c/reactions.json": 59208,
	"./assignments/en/chemvlab/stoichiometry/Activity4_c/solutions.json": 48284,
	"./assignments/en/chemvlab/stoichiometry/Activity4_c/species.json": 75914,
	"./assignments/en/chemvlab/stoichiometry/Activity4_c/spectra.json": 58844,
	"./assignments/en/chemvlab/stoichiometry/Activity4_d/assignment.json": 45286,
	"./assignments/en/chemvlab/stoichiometry/Activity4_d/configuration.json": 57563,
	"./assignments/en/chemvlab/stoichiometry/Activity4_d/reactions.json": 20317,
	"./assignments/en/chemvlab/stoichiometry/Activity4_d/solutions.json": 34457,
	"./assignments/en/chemvlab/stoichiometry/Activity4_d/species.json": 75079,
	"./assignments/en/chemvlab/stoichiometry/Activity4_d/spectra.json": 7121,
	"./assignments/en/chemvlab/stoichiometry/chloride_ga/assignment.json": 93837,
	"./assignments/en/chemvlab/stoichiometry/chloride_ga/configuration.json": 6254,
	"./assignments/en/chemvlab/stoichiometry/chloride_ga/reactions.json": 85088,
	"./assignments/en/chemvlab/stoichiometry/chloride_ga/solutions.json": 72500,
	"./assignments/en/chemvlab/stoichiometry/chloride_ga/species.json": 80898,
	"./assignments/en/chemvlab/stoichiometry/chloride_ga/spectra.json": 3844,
	"./assignments/en/chemvlab/stoichiometry/chloride_precip/assignment.json": 29708,
	"./assignments/en/chemvlab/stoichiometry/chloride_precip/configuration.json": 80489,
	"./assignments/en/chemvlab/stoichiometry/chloride_precip/reactions.json": 21527,
	"./assignments/en/chemvlab/stoichiometry/chloride_precip/solutions.json": 28347,
	"./assignments/en/chemvlab/stoichiometry/chloride_precip/species.json": 39273,
	"./assignments/en/chemvlab/stoichiometry/chloride_precip/spectra.json": 64131,
	"./assignments/en/chemvlab/stoichiometry/lead_ga/assignment.json": 53255,
	"./assignments/en/chemvlab/stoichiometry/lead_ga/configuration.json": 28456,
	"./assignments/en/chemvlab/stoichiometry/lead_ga/reactions.json": 16254,
	"./assignments/en/chemvlab/stoichiometry/lead_ga/solutions.json": 49026,
	"./assignments/en/chemvlab/stoichiometry/lead_ga/species.json": 97416,
	"./assignments/en/chemvlab/stoichiometry/lead_ga/spectra.json": 3258,
	"./assignments/en/chemvlab/stoichiometry/lead_precip/assignment.json": 64850,
	"./assignments/en/chemvlab/stoichiometry/lead_precip/configuration.json": 22079,
	"./assignments/en/chemvlab/stoichiometry/lead_precip/reactions.json": 8753,
	"./assignments/en/chemvlab/stoichiometry/lead_precip/solutions.json": 36701,
	"./assignments/en/chemvlab/stoichiometry/lead_precip/species.json": 65195,
	"./assignments/en/chemvlab/stoichiometry/lead_precip/spectra.json": 46773,
	"./assignments/en/chemvlab/thermodynamics/Cobalt/assignment.json": 39813,
	"./assignments/en/chemvlab/thermodynamics/Cobalt/configuration.json": 83990,
	"./assignments/en/chemvlab/thermodynamics/Cobalt/reactions.json": 9464,
	"./assignments/en/chemvlab/thermodynamics/Cobalt/solutions.json": 84460,
	"./assignments/en/chemvlab/thermodynamics/Cobalt/species.json": 31546,
	"./assignments/en/chemvlab/thermodynamics/Cobalt/spectra.json": 72204,
	"./assignments/en/chemvlab/thermodynamics/Cobalt2/assignment.json": 7685,
	"./assignments/en/chemvlab/thermodynamics/Cobalt2/configuration.json": 24374,
	"./assignments/en/chemvlab/thermodynamics/Cobalt2/reactions.json": 15512,
	"./assignments/en/chemvlab/thermodynamics/Cobalt2/solutions.json": 79692,
	"./assignments/en/chemvlab/thermodynamics/Cobalt2/species.json": 506,
	"./assignments/en/chemvlab/thermodynamics/Cobalt2/spectra.json": 42348,
	"./assignments/en/chemvlab/thermodynamics/Hotcold1/assignment.json": 69568,
	"./assignments/en/chemvlab/thermodynamics/Hotcold1/configuration.json": 57301,
	"./assignments/en/chemvlab/thermodynamics/Hotcold1/reactions.json": 64755,
	"./assignments/en/chemvlab/thermodynamics/Hotcold1/solutions.json": 85303,
	"./assignments/en/chemvlab/thermodynamics/Hotcold1/species.json": 16149,
	"./assignments/en/chemvlab/thermodynamics/Hotcold1/spectra.json": 87647,
	"./assignments/en/chemvlab/thermodynamics/Hotcold2/assignment.json": 66287,
	"./assignments/en/chemvlab/thermodynamics/Hotcold2/configuration.json": 16928,
	"./assignments/en/chemvlab/thermodynamics/Hotcold2/reactions.json": 30982,
	"./assignments/en/chemvlab/thermodynamics/Hotcold2/solutions.json": 63722,
	"./assignments/en/chemvlab/thermodynamics/Hotcold2/species.json": 78640,
	"./assignments/en/chemvlab/thermodynamics/Hotcold2/spectra.json": 94290,
	"./assignments/en/chemvlab/thermodynamics/Solar1/assignment.json": 24052,
	"./assignments/en/chemvlab/thermodynamics/Solar1/configuration.json": 14657,
	"./assignments/en/chemvlab/thermodynamics/Solar1/reactions.json": 64575,
	"./assignments/en/chemvlab/thermodynamics/Solar1/solutions.json": 61539,
	"./assignments/en/chemvlab/thermodynamics/Solar1/species.json": 39633,
	"./assignments/en/chemvlab/thermodynamics/Solar1/spectra.json": 65691,
	"./assignments/en/chemvlab/thermodynamics/Solar2/assignment.json": 43587,
	"./assignments/en/chemvlab/thermodynamics/Solar2/configuration.json": 55948,
	"./assignments/en/chemvlab/thermodynamics/Solar2/reactions.json": 12322,
	"./assignments/en/chemvlab/thermodynamics/Solar2/solutions.json": 84854,
	"./assignments/en/chemvlab/thermodynamics/Solar2/species.json": 74988,
	"./assignments/en/chemvlab/thermodynamics/Solar2/spectra.json": 29790,
	"./assignments/en/chemvlab/thermodynamics/Swim1/assignment.json": 79321,
	"./assignments/en/chemvlab/thermodynamics/Swim1/configuration.json": 86594,
	"./assignments/en/chemvlab/thermodynamics/Swim1/reactions.json": 77172,
	"./assignments/en/chemvlab/thermodynamics/Swim1/solutions.json": 1768,
	"./assignments/en/chemvlab/thermodynamics/Swim1/species.json": 80742,
	"./assignments/en/chemvlab/thermodynamics/Swim1/spectra.json": 73272,
	"./assignments/en/chemvlab/thermodynamics/Swim2/assignment.json": 87750,
	"./assignments/en/chemvlab/thermodynamics/Swim2/configuration.json": 65371,
	"./assignments/en/chemvlab/thermodynamics/Swim2/reactions.json": 68413,
	"./assignments/en/chemvlab/thermodynamics/Swim2/solutions.json": 82553,
	"./assignments/en/chemvlab/thermodynamics/Swim2/species.json": 96487,
	"./assignments/en/chemvlab/thermodynamics/Swim2/spectra.json": 28529,
	"./assignments/en/chemvlab/thermodynamics/Swim3/assignment.json": 46311,
	"./assignments/en/chemvlab/thermodynamics/Swim3/configuration.json": 80680,
	"./assignments/en/chemvlab/thermodynamics/Swim3/reactions.json": 84190,
	"./assignments/en/chemvlab/thermodynamics/Swim3/solutions.json": 22946,
	"./assignments/en/chemvlab/thermodynamics/Swim3/species.json": 3048,
	"./assignments/en/chemvlab/thermodynamics/Swim3/spectra.json": 42522,
	"./assignments/en/chemvlab/thermodynamics/Swim4/assignment.json": 75524,
	"./assignments/en/chemvlab/thermodynamics/Swim4/configuration.json": 53105,
	"./assignments/en/chemvlab/thermodynamics/Swim4/reactions.json": 61871,
	"./assignments/en/chemvlab/thermodynamics/Swim4/solutions.json": 8371,
	"./assignments/en/chemvlab/thermodynamics/Swim4/species.json": 7777,
	"./assignments/en/chemvlab/thermodynamics/Swim4/spectra.json": 16907,
	"./assignments/en/chemvlab/thermodynamics/Swim5/assignment.json": 17557,
	"./assignments/en/chemvlab/thermodynamics/Swim5/configuration.json": 50470,
	"./assignments/en/chemvlab/thermodynamics/Swim5/reactions.json": 7304,
	"./assignments/en/chemvlab/thermodynamics/Swim5/solutions.json": 96380,
	"./assignments/en/chemvlab/thermodynamics/Swim5/species.json": 97322,
	"./assignments/en/chemvlab/thermodynamics/Swim5/spectra.json": 80252,
	"./assignments/en/chemvlab/thermodynamics/Swim6/assignment.json": 42754,
	"./assignments/en/chemvlab/thermodynamics/Swim6/configuration.json": 61583,
	"./assignments/en/chemvlab/thermodynamics/Swim6/reactions.json": 89825,
	"./assignments/en/chemvlab/thermodynamics/Swim6/solutions.json": 70605,
	"./assignments/en/chemvlab/thermodynamics/Swim6/species.json": 49723,
	"./assignments/en/chemvlab/thermodynamics/Swim6/spectra.json": 81445,
	"./assignments/en/chemvlab/thermodynamics/Swim7/assignment.json": 57299,
	"./assignments/en/chemvlab/thermodynamics/Swim7/configuration.json": 37852,
	"./assignments/en/chemvlab/thermodynamics/Swim7/reactions.json": 1298,
	"./assignments/en/chemvlab/thermodynamics/Swim7/solutions.json": 79014,
	"./assignments/en/chemvlab/thermodynamics/Swim7/species.json": 74300,
	"./assignments/en/chemvlab/thermodynamics/Swim7/spectra.json": 28174,
	"./assignments/en/chemvlab/thermodynamics/Thiocyanate/assignment.json": 98687,
	"./assignments/en/chemvlab/thermodynamics/Thiocyanate/configuration.json": 76208,
	"./assignments/en/chemvlab/thermodynamics/Thiocyanate/reactions.json": 87638,
	"./assignments/en/chemvlab/thermodynamics/Thiocyanate/solutions.json": 13658,
	"./assignments/en/chemvlab/thermodynamics/Thiocyanate/species.json": 45472,
	"./assignments/en/chemvlab/thermodynamics/Thiocyanate/spectra.json": 80610,
	"./assignments/en/colligative/bp_elevation/assignment.json": 12657,
	"./assignments/en/colligative/bp_elevation/configuration.json": 18282,
	"./assignments/en/colligative/bp_elevation/reactions.json": 34700,
	"./assignments/en/colligative/bp_elevation/solutions.json": 8544,
	"./assignments/en/colligative/bp_elevation/species.json": 7294,
	"./assignments/en/colligative/bp_elevation/spectra.json": 37184,
	"./assignments/en/colligative/solution_nonaq/assignment.json": 7804,
	"./assignments/en/colligative/solution_nonaq/configuration.json": 13273,
	"./assignments/en/colligative/solution_nonaq/reactions.json": 88615,
	"./assignments/en/colligative/solution_nonaq/solutions.json": 41035,
	"./assignments/en/colligative/solution_nonaq/species.json": 43417,
	"./assignments/en/colligative/solution_nonaq/spectra.json": 93235,
	"./assignments/en/colligative/vapor_pressure/assignment.json": 54811,
	"./assignments/en/colligative/vapor_pressure/configuration.json": 98004,
	"./assignments/en/colligative/vapor_pressure/reactions.json": 5018,
	"./assignments/en/colligative/vapor_pressure/solutions.json": 16814,
	"./assignments/en/colligative/vapor_pressure/species.json": 41892,
	"./assignments/en/colligative/vapor_pressure/spectra.json": 2329,
	"./assignments/en/default/assignment.json": 41826,
	"./assignments/en/default/configuration.json": 20271,
	"./assignments/en/default/reactions.json": 15297,
	"./assignments/en/default/solutions.json": 74029,
	"./assignments/en/default/species.json": 57339,
	"./assignments/en/default/spectra.json": 57093,
	"./assignments/en/hotcoldpack/assignment.json": 2561,
	"./assignments/en/hotcoldpack/configuration.json": 2042,
	"./assignments/en/hotcoldpack/reactions.json": 34940,
	"./assignments/en/hotcoldpack/solutions.json": 24528,
	"./assignments/en/hotcoldpack/species.json": 69486,
	"./assignments/en/hotcoldpack/spectra.json": 11632,
	"./assignments/en/iron_thiocyanate/assignment.json": 16835,
	"./assignments/en/iron_thiocyanate/configuration.json": 27436,
	"./assignments/en/iron_thiocyanate/reactions.json": 52866,
	"./assignments/en/iron_thiocyanate/solutions.json": 31254,
	"./assignments/en/iron_thiocyanate/species.json": 49868,
	"./assignments/en/iron_thiocyanate/spectra.json": 42366,
	"./assignments/en/kinetics/cv_bleaching/assignment.json": 23811,
	"./assignments/en/kinetics/cv_bleaching/configuration.json": 18892,
	"./assignments/en/kinetics/cv_bleaching/reactions.json": 46658,
	"./assignments/en/kinetics/cv_bleaching/solutions.json": 2838,
	"./assignments/en/kinetics/cv_bleaching/species.json": 32460,
	"./assignments/en/kinetics/cv_bleaching/spectra.json": 87262,
	"./assignments/en/kinetics/iodide_persulfate/assignment.json": 28380,
	"./assignments/en/kinetics/iodide_persulfate/configuration.json": 37017,
	"./assignments/en/kinetics/iodide_persulfate/reactions.json": 45191,
	"./assignments/en/kinetics/iodide_persulfate/solutions.json": 75307,
	"./assignments/en/kinetics/iodide_persulfate/species.json": 95705,
	"./assignments/en/kinetics/iodide_persulfate/spectra.json": 18803,
	"./assignments/en/kinetics/k1/assignment.json": 78182,
	"./assignments/en/kinetics/k1/configuration.json": 29531,
	"./assignments/en/kinetics/k1/reactions.json": 92861,
	"./assignments/en/kinetics/k1/solutions.json": 44057,
	"./assignments/en/kinetics/k1/species.json": 48199,
	"./assignments/en/kinetics/k1/spectra.json": 15409,
	"./assignments/en/kinetics/k2/assignment.json": 64121,
	"./assignments/en/kinetics/k2/configuration.json": 4770,
	"./assignments/en/kinetics/k2/reactions.json": 5172,
	"./assignments/en/kinetics/k2/solutions.json": 7240,
	"./assignments/en/kinetics/k2/species.json": 68806,
	"./assignments/en/kinetics/k2/spectra.json": 70392,
	"./assignments/en/kinetics/k3/assignment.json": 79640,
	"./assignments/en/kinetics/k3/configuration.json": 82717,
	"./assignments/en/kinetics/k3/reactions.json": 51371,
	"./assignments/en/kinetics/k3/solutions.json": 15439,
	"./assignments/en/kinetics/k3/species.json": 64685,
	"./assignments/en/kinetics/k3/spectra.json": 83495,
	"./assignments/en/kinetics/k4equilibrium/assignment.json": 92013,
	"./assignments/en/kinetics/k4equilibrium/configuration.json": 9070,
	"./assignments/en/kinetics/k4equilibrium/reactions.json": 45600,
	"./assignments/en/kinetics/k4equilibrium/solutions.json": 14228,
	"./assignments/en/kinetics/k4equilibrium/species.json": 93954,
	"./assignments/en/kinetics/k4equilibrium/spectra.json": 76228,
	"./assignments/en/kinetics/k5/assignment.json": 35106,
	"./assignments/en/kinetics/k5/configuration.json": 1935,
	"./assignments/en/kinetics/k5/reactions.json": 67041,
	"./assignments/en/kinetics/k5/solutions.json": 26925,
	"./assignments/en/kinetics/k5/species.json": 79867,
	"./assignments/en/kinetics/k5/spectra.json": 68229,
	"./assignments/en/metals/assignment.json": 12455,
	"./assignments/en/metals/configuration.json": 29128,
	"./assignments/en/metals/reactions.json": 58174,
	"./assignments/en/metals/solutions.json": 90946,
	"./assignments/en/metals/species.json": 10760,
	"./assignments/en/metals/spectra.json": 16602,
	"./assignments/en/oracle-1/assignment.json": 12711,
	"./assignments/en/oracle-1/configuration.json": 82600,
	"./assignments/en/oracle-1/reactions.json": 5918,
	"./assignments/en/oracle-1/solutions.json": 49506,
	"./assignments/en/oracle-1/species.json": 30088,
	"./assignments/en/oracle-1/spectra.json": 52762,
	"./assignments/en/oracle-2/assignment.json": 92792,
	"./assignments/en/oracle-2/configuration.json": 31581,
	"./assignments/en/oracle-2/reactions.json": 40587,
	"./assignments/en/oracle-2/solutions.json": 4655,
	"./assignments/en/oracle-2/species.json": 85773,
	"./assignments/en/oracle-2/spectra.json": 4583,
	"./assignments/en/oracle-2_2/assignment.json": 50139,
	"./assignments/en/oracle-2_2/configuration.json": 564,
	"./assignments/en/oracle-2_2/reactions.json": 66170,
	"./assignments/en/oracle-2_2/solutions.json": 48430,
	"./assignments/en/oracle-2_2/species.json": 27236,
	"./assignments/en/oracle-2_2/spectra.json": 2086,
	"./assignments/en/oracle-3/assignment.json": 77273,
	"./assignments/en/oracle-3/configuration.json": 53634,
	"./assignments/en/oracle-3/reactions.json": 94388,
	"./assignments/en/oracle-3/solutions.json": 96456,
	"./assignments/en/oracle-3/species.json": 89894,
	"./assignments/en/oracle-3/spectra.json": 91480,
	"./assignments/en/oracle-3_2/assignment.json": 54674,
	"./assignments/en/oracle-3_2/configuration.json": 13759,
	"./assignments/en/oracle-3_2/reactions.json": 9009,
	"./assignments/en/oracle-3_2/solutions.json": 35837,
	"./assignments/en/oracle-3_2/species.json": 45387,
	"./assignments/en/oracle-3_2/spectra.json": 76981,
	"./assignments/en/oracle-4/assignment.json": 48258,
	"./assignments/en/oracle-4/configuration.json": 50799,
	"./assignments/en/oracle-4/reactions.json": 56257,
	"./assignments/en/oracle-4/solutions.json": 16141,
	"./assignments/en/oracle-4/species.json": 955,
	"./assignments/en/oracle-4/spectra.json": 72965,
	"./assignments/en/oracle-temp-1/assignment.json": 42314,
	"./assignments/en/oracle-temp-1/configuration.json": 60679,
	"./assignments/en/oracle-temp-1/reactions.json": 58921,
	"./assignments/en/oracle-temp-1/solutions.json": 78677,
	"./assignments/en/oracle-temp-1/species.json": 87651,
	"./assignments/en/oracle-temp-1/spectra.json": 48317,
	"./assignments/en/oracle-temp-2/assignment.json": 73821,
	"./assignments/en/oracle-temp-2/configuration.json": 59710,
	"./assignments/en/oracle-temp-2/reactions.json": 91024,
	"./assignments/en/oracle-temp-2/solutions.json": 52708,
	"./assignments/en/oracle-temp-2/species.json": 42386,
	"./assignments/en/oracle-temp-2/spectra.json": 77268,
	"./assignments/en/oracle-temp-2b/assignment.json": 96253,
	"./assignments/en/oracle-temp-2b/configuration.json": 36990,
	"./assignments/en/oracle-temp-2b/reactions.json": 44688,
	"./assignments/en/oracle-temp-2b/solutions.json": 57508,
	"./assignments/en/oracle-temp-2b/species.json": 63538,
	"./assignments/en/oracle-temp-2b/spectra.json": 18580,
	"./assignments/en/oracle-temp-3/assignment.json": 59148,
	"./assignments/en/oracle-temp-3/configuration.json": 18569,
	"./assignments/en/oracle-temp-3/reactions.json": 54711,
	"./assignments/en/oracle-temp-3/solutions.json": 99227,
	"./assignments/en/oracle-temp-3/species.json": 96521,
	"./assignments/en/oracle-temp-3/spectra.json": 34051,
	"./assignments/en/oracle-temp-3b/assignment.json": 55290,
	"./assignments/en/oracle-temp-3b/configuration.json": 29015,
	"./assignments/en/oracle-temp-3b/reactions.json": 74649,
	"./assignments/en/oracle-temp-3b/solutions.json": 99333,
	"./assignments/en/oracle-temp-3b/species.json": 33587,
	"./assignments/en/oracle-temp-3b/spectra.json": 7277,
	"./assignments/en/oracle-temp-4/assignment.json": 3023,
	"./assignments/en/oracle-temp-4/configuration.json": 68096,
	"./assignments/en/oracle-temp-4/reactions.json": 56102,
	"./assignments/en/oracle-temp-4/solutions.json": 71018,
	"./assignments/en/oracle-temp-4/species.json": 82576,
	"./assignments/en/oracle-temp-4/spectra.json": 9618,
	"./assignments/en/solids/solubility/assignment.json": 60322,
	"./assignments/en/solids/solubility/configuration.json": 14895,
	"./assignments/en/solids/solubility/reactions.json": 27489,
	"./assignments/en/solids/solubility/solutions.json": 8269,
	"./assignments/en/solids/solubility/species.json": 19387,
	"./assignments/en/solids/solubility/spectra.json": 51109,
	"./assignments/en/solids/solubilityLargeHeat/assignment.json": 18617,
	"./assignments/en/solids/solubilityLargeHeat/configuration.json": 68674,
	"./assignments/en/solids/solubilityLargeHeat/reactions.json": 63444,
	"./assignments/en/solids/solubilityLargeHeat/solutions.json": 88040,
	"./assignments/en/solids/solubilityLargeHeat/species.json": 48294,
	"./assignments/en/solids/solubilityLargeHeat/spectra.json": 24472,
	"./assignments/en/solubility/assignment.json": 79171,
	"./assignments/en/solubility/configuration.json": 88300,
	"./assignments/en/solubility/reactions.json": 60354,
	"./assignments/en/solubility/solutions.json": 38742,
	"./assignments/en/solubility/species.json": 70124,
	"./assignments/en/solubility/spectra.json": 78974,
	"./assignments/en/study/assignment.json": 73618,
	"./assignments/en/study/configuration.json": 26975,
	"./assignments/en/study/reactions.json": 26705,
	"./assignments/en/study/solutions.json": 53533,
	"./assignments/en/study/species.json": 38155,
	"./assignments/en/study/spectra.json": 69749,
	"./assignments/en/test/assignment.json": 78383,
	"./assignments/en/test/configuration.json": 45760,
	"./assignments/en/test/reactions.json": 9350,
	"./assignments/en/test/solutions.json": 35594,
	"./assignments/en/test/species.json": 82032,
	"./assignments/en/test/spectra.json": 19698,
	"./assignments/es/default/assignment.json": 58407,
	"./assignments/es/default/configuration.json": 87496,
	"./assignments/es/default/reactions.json": 40894,
	"./assignments/es/default/solutions.json": 79650,
	"./assignments/es/default/species.json": 36072,
	"./assignments/es/default/spectra.json": 75546,
	"./assignments_chemv_en.json": 19806,
	"./assignments_en.json": 69788,
	"./assignments_es.json": 299,
	"resources/assignments/en/MolarityDensity/dilution/assignment.json": 18789,
	"resources/assignments/en/MolarityDensity/dilution/configuration.json": 70934,
	"resources/assignments/en/MolarityDensity/dilution/reactions.json": 58392,
	"resources/assignments/en/MolarityDensity/dilution/solutions.json": 33388,
	"resources/assignments/en/MolarityDensity/dilution/species.json": 65722,
	"resources/assignments/en/MolarityDensity/dilution/spectra.json": 22732,
	"resources/assignments/en/MolarityDensity/sucrose/assignment.json": 46127,
	"resources/assignments/en/MolarityDensity/sucrose/configuration.json": 85760,
	"resources/assignments/en/MolarityDensity/sucrose/reactions.json": 45542,
	"resources/assignments/en/MolarityDensity/sucrose/solutions.json": 60458,
	"resources/assignments/en/MolarityDensity/sucrose/species.json": 3568,
	"resources/assignments/en/MolarityDensity/sucrose/spectra.json": 46962,
	"resources/assignments/en/Redox/redox/assignment.json": 87288,
	"resources/assignments/en/Redox/redox/configuration.json": 68285,
	"resources/assignments/en/Redox/redox/reactions.json": 93483,
	"resources/assignments/en/Redox/redox/solutions.json": 41199,
	"resources/assignments/en/Redox/redox/species.json": 44493,
	"resources/assignments/en/Redox/redox/spectra.json": 63303,
	"resources/assignments/en/Redox/redox2/assignment.json": 66062,
	"resources/assignments/en/Redox/redox2/configuration.json": 41203,
	"resources/assignments/en/Redox/redox2/reactions.json": 10373,
	"resources/assignments/en/Redox/redox2/solutions.json": 85601,
	"resources/assignments/en/Redox/redox2/species.json": 54447,
	"resources/assignments/en/Redox/redox2/spectra.json": 96553,
	"resources/assignments/en/chem207/exp01/assignment.json": 91092,
	"resources/assignments/en/chem207/exp01/configuration.json": 92673,
	"resources/assignments/en/chem207/exp01/reactions.json": 89055,
	"resources/assignments/en/chem207/exp01/solutions.json": 68739,
	"resources/assignments/en/chem207/exp01/species.json": 69905,
	"resources/assignments/en/chem207/exp01/spectra.json": 33819,
	"resources/assignments/en/chemvlab/IV/IV_dilute_saline/assignment.json": 41388,
	"resources/assignments/en/chemvlab/IV/IV_dilute_saline/configuration.json": 14921,
	"resources/assignments/en/chemvlab/IV/IV_dilute_saline/reactions.json": 27799,
	"resources/assignments/en/chemvlab/IV/IV_dilute_saline/solutions.json": 45595,
	"resources/assignments/en/chemvlab/IV/IV_dilute_saline/species.json": 40969,
	"resources/assignments/en/chemvlab/IV/IV_dilute_saline/spectra.json": 89379,
	"resources/assignments/en/chemvlab/IV/IV_iodine_12/assignment.json": 61514,
	"resources/assignments/en/chemvlab/IV/IV_iodine_12/configuration.json": 50567,
	"resources/assignments/en/chemvlab/IV/IV_iodine_12/reactions.json": 89705,
	"resources/assignments/en/chemvlab/IV/IV_iodine_12/solutions.json": 71093,
	"resources/assignments/en/chemvlab/IV/IV_iodine_12/species.json": 88643,
	"resources/assignments/en/chemvlab/IV/IV_iodine_12/spectra.json": 66909,
	"resources/assignments/en/chemvlab/IV/IV_iodine_18/assignment.json": 36244,
	"resources/assignments/en/chemvlab/IV/IV_iodine_18/configuration.json": 19585,
	"resources/assignments/en/chemvlab/IV/IV_iodine_18/reactions.json": 56479,
	"resources/assignments/en/chemvlab/IV/IV_iodine_18/solutions.json": 53443,
	"resources/assignments/en/chemvlab/IV/IV_iodine_18/species.json": 13905,
	"resources/assignments/en/chemvlab/IV/IV_iodine_18/spectra.json": 23611,
	"resources/assignments/en/chemvlab/IV/IV_make_glucose/assignment.json": 94277,
	"resources/assignments/en/chemvlab/IV/IV_make_glucose/configuration.json": 33334,
	"resources/assignments/en/chemvlab/IV/IV_make_glucose/reactions.json": 68376,
	"resources/assignments/en/chemvlab/IV/IV_make_glucose/solutions.json": 32556,
	"resources/assignments/en/chemvlab/IV/IV_make_glucose/species.json": 72122,
	"resources/assignments/en/chemvlab/IV/IV_make_glucose/spectra.json": 13964,
	"resources/assignments/en/chemvlab/IV/IV_make_glucose2/assignment.json": 64421,
	"resources/assignments/en/chemvlab/IV/IV_make_glucose2/configuration.json": 25750,
	"resources/assignments/en/chemvlab/IV/IV_make_glucose2/reactions.json": 31864,
	"resources/assignments/en/chemvlab/IV/IV_make_glucose2/solutions.json": 75212,
	"resources/assignments/en/chemvlab/IV/IV_make_glucose2/species.json": 52026,
	"resources/assignments/en/chemvlab/IV/IV_make_glucose2/spectra.json": 71980,
	"resources/assignments/en/chemvlab/IV/IV_make_saline/assignment.json": 16273,
	"resources/assignments/en/chemvlab/IV/IV_make_saline/configuration.json": 58282,
	"resources/assignments/en/chemvlab/IV/IV_make_saline/reactions.json": 98124,
	"resources/assignments/en/chemvlab/IV/IV_make_saline/solutions.json": 92128,
	"resources/assignments/en/chemvlab/IV/IV_make_saline/species.json": 69502,
	"resources/assignments/en/chemvlab/IV/IV_make_saline/spectra.json": 68768,
	"resources/assignments/en/chemvlab/stoichiometry/Activity1_a/assignment.json": 79206,
	"resources/assignments/en/chemvlab/stoichiometry/Activity1_a/configuration.json": 78171,
	"resources/assignments/en/chemvlab/stoichiometry/Activity1_a/reactions.json": 24797,
	"resources/assignments/en/chemvlab/stoichiometry/Activity1_a/solutions.json": 39513,
	"resources/assignments/en/chemvlab/stoichiometry/Activity1_a/species.json": 43559,
	"resources/assignments/en/chemvlab/stoichiometry/Activity1_a/spectra.json": 12369,
	"resources/assignments/en/chemvlab/stoichiometry/Activity1_b/assignment.json": 60313,
	"resources/assignments/en/chemvlab/stoichiometry/Activity1_b/configuration.json": 70594,
	"resources/assignments/en/chemvlab/stoichiometry/Activity1_b/reactions.json": 44756,
	"resources/assignments/en/chemvlab/stoichiometry/Activity1_b/solutions.json": 76232,
	"resources/assignments/en/chemvlab/stoichiometry/Activity1_b/species.json": 24710,
	"resources/assignments/en/chemvlab/stoichiometry/Activity1_b/spectra.json": 42936,
	"resources/assignments/en/chemvlab/stoichiometry/Activity2_a/assignment.json": 22245,
	"resources/assignments/en/chemvlab/stoichiometry/Activity2_a/configuration.json": 28150,
	"resources/assignments/en/chemvlab/stoichiometry/Activity2_a/reactions.json": 48728,
	"resources/assignments/en/chemvlab/stoichiometry/Activity2_a/solutions.json": 92076,
	"resources/assignments/en/chemvlab/stoichiometry/Activity2_a/species.json": 55386,
	"resources/assignments/en/chemvlab/stoichiometry/Activity2_a/spectra.json": 91692,
	"resources/assignments/en/chemvlab/stoichiometry/Activity2_b/assignment.json": 89010,
	"resources/assignments/en/chemvlab/stoichiometry/Activity2_b/configuration.json": 36095,
	"resources/assignments/en/chemvlab/stoichiometry/Activity2_b/reactions.json": 91729,
	"resources/assignments/en/chemvlab/stoichiometry/Activity2_b/solutions.json": 61469,
	"resources/assignments/en/chemvlab/stoichiometry/Activity2_b/species.json": 93931,
	"resources/assignments/en/chemvlab/stoichiometry/Activity2_b/spectra.json": 10965,
	"resources/assignments/en/chemvlab/stoichiometry/Activity2_c/assignment.json": 51523,
	"resources/assignments/en/chemvlab/stoichiometry/Activity2_c/configuration.json": 73036,
	"resources/assignments/en/chemvlab/stoichiometry/Activity2_c/reactions.json": 29858,
	"resources/assignments/en/chemvlab/stoichiometry/Activity2_c/solutions.json": 86038,
	"resources/assignments/en/chemvlab/stoichiometry/Activity2_c/species.json": 19308,
	"resources/assignments/en/chemvlab/stoichiometry/Activity2_c/spectra.json": 74110,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_a/assignment.json": 716,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_a/configuration.json": 95241,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_a/reactions.json": 2647,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_a/solutions.json": 20443,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_a/species.json": 10857,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_a/spectra.json": 59267,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_b/assignment.json": 83163,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_b/configuration.json": 18292,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_b/reactions.json": 63866,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_b/solutions.json": 59310,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_b/species.json": 72612,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_b/spectra.json": 39078,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_c/assignment.json": 20746,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_c/configuration.json": 17959,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_c/reactions.json": 5129,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_c/solutions.json": 65685,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_c/species.json": 59971,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_c/spectra.json": 26109,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_d/assignment.json": 18081,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_d/configuration.json": 2778,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_d/reactions.json": 80508,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_d/solutions.json": 22352,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_d/species.json": 10574,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_d/spectra.json": 31760,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_e/assignment.json": 60096,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_e/configuration.json": 79381,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_e/reactions.json": 1587,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_e/solutions.json": 5783,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_e/species.json": 149,
	"resources/assignments/en/chemvlab/stoichiometry/Activity3_e/spectra.json": 71647,
	"resources/assignments/en/chemvlab/stoichiometry/Activity4_a/assignment.json": 14835,
	"resources/assignments/en/chemvlab/stoichiometry/Activity4_a/configuration.json": 13692,
	"resources/assignments/en/chemvlab/stoichiometry/Activity4_a/reactions.json": 53202,
	"resources/assignments/en/chemvlab/stoichiometry/Activity4_a/solutions.json": 30918,
	"resources/assignments/en/chemvlab/stoichiometry/Activity4_a/species.json": 52892,
	"resources/assignments/en/chemvlab/stoichiometry/Activity4_a/spectra.json": 6766,
	"resources/assignments/en/chemvlab/stoichiometry/Activity4_b/assignment.json": 33060,
	"resources/assignments/en/chemvlab/stoichiometry/Activity4_b/configuration.json": 28945,
	"resources/assignments/en/chemvlab/stoichiometry/Activity4_b/reactions.json": 30127,
	"resources/assignments/en/chemvlab/stoichiometry/Activity4_b/solutions.json": 76627,
	"resources/assignments/en/chemvlab/stoichiometry/Activity4_b/species.json": 86369,
	"resources/assignments/en/chemvlab/stoichiometry/Activity4_b/spectra.json": 95499,
	"resources/assignments/en/chemvlab/stoichiometry/Activity4_c/assignment.json": 58741,
	"resources/assignments/en/chemvlab/stoichiometry/Activity4_c/configuration.json": 26310,
	"resources/assignments/en/chemvlab/stoichiometry/Activity4_c/reactions.json": 59208,
	"resources/assignments/en/chemvlab/stoichiometry/Activity4_c/solutions.json": 48284,
	"resources/assignments/en/chemvlab/stoichiometry/Activity4_c/species.json": 75914,
	"resources/assignments/en/chemvlab/stoichiometry/Activity4_c/spectra.json": 58844,
	"resources/assignments/en/chemvlab/stoichiometry/Activity4_d/assignment.json": 45286,
	"resources/assignments/en/chemvlab/stoichiometry/Activity4_d/configuration.json": 57563,
	"resources/assignments/en/chemvlab/stoichiometry/Activity4_d/reactions.json": 20317,
	"resources/assignments/en/chemvlab/stoichiometry/Activity4_d/solutions.json": 34457,
	"resources/assignments/en/chemvlab/stoichiometry/Activity4_d/species.json": 75079,
	"resources/assignments/en/chemvlab/stoichiometry/Activity4_d/spectra.json": 7121,
	"resources/assignments/en/chemvlab/stoichiometry/chloride_ga/assignment.json": 93837,
	"resources/assignments/en/chemvlab/stoichiometry/chloride_ga/configuration.json": 6254,
	"resources/assignments/en/chemvlab/stoichiometry/chloride_ga/reactions.json": 85088,
	"resources/assignments/en/chemvlab/stoichiometry/chloride_ga/solutions.json": 72500,
	"resources/assignments/en/chemvlab/stoichiometry/chloride_ga/species.json": 80898,
	"resources/assignments/en/chemvlab/stoichiometry/chloride_ga/spectra.json": 3844,
	"resources/assignments/en/chemvlab/stoichiometry/chloride_precip/assignment.json": 29708,
	"resources/assignments/en/chemvlab/stoichiometry/chloride_precip/configuration.json": 80489,
	"resources/assignments/en/chemvlab/stoichiometry/chloride_precip/reactions.json": 21527,
	"resources/assignments/en/chemvlab/stoichiometry/chloride_precip/solutions.json": 28347,
	"resources/assignments/en/chemvlab/stoichiometry/chloride_precip/species.json": 39273,
	"resources/assignments/en/chemvlab/stoichiometry/chloride_precip/spectra.json": 64131,
	"resources/assignments/en/chemvlab/stoichiometry/lead_ga/assignment.json": 53255,
	"resources/assignments/en/chemvlab/stoichiometry/lead_ga/configuration.json": 28456,
	"resources/assignments/en/chemvlab/stoichiometry/lead_ga/reactions.json": 16254,
	"resources/assignments/en/chemvlab/stoichiometry/lead_ga/solutions.json": 49026,
	"resources/assignments/en/chemvlab/stoichiometry/lead_ga/species.json": 97416,
	"resources/assignments/en/chemvlab/stoichiometry/lead_ga/spectra.json": 3258,
	"resources/assignments/en/chemvlab/stoichiometry/lead_precip/assignment.json": 64850,
	"resources/assignments/en/chemvlab/stoichiometry/lead_precip/configuration.json": 22079,
	"resources/assignments/en/chemvlab/stoichiometry/lead_precip/reactions.json": 8753,
	"resources/assignments/en/chemvlab/stoichiometry/lead_precip/solutions.json": 36701,
	"resources/assignments/en/chemvlab/stoichiometry/lead_precip/species.json": 65195,
	"resources/assignments/en/chemvlab/stoichiometry/lead_precip/spectra.json": 46773,
	"resources/assignments/en/chemvlab/thermodynamics/Cobalt/assignment.json": 39813,
	"resources/assignments/en/chemvlab/thermodynamics/Cobalt/configuration.json": 83990,
	"resources/assignments/en/chemvlab/thermodynamics/Cobalt/reactions.json": 9464,
	"resources/assignments/en/chemvlab/thermodynamics/Cobalt/solutions.json": 84460,
	"resources/assignments/en/chemvlab/thermodynamics/Cobalt/species.json": 31546,
	"resources/assignments/en/chemvlab/thermodynamics/Cobalt/spectra.json": 72204,
	"resources/assignments/en/chemvlab/thermodynamics/Cobalt2/assignment.json": 7685,
	"resources/assignments/en/chemvlab/thermodynamics/Cobalt2/configuration.json": 24374,
	"resources/assignments/en/chemvlab/thermodynamics/Cobalt2/reactions.json": 15512,
	"resources/assignments/en/chemvlab/thermodynamics/Cobalt2/solutions.json": 79692,
	"resources/assignments/en/chemvlab/thermodynamics/Cobalt2/species.json": 506,
	"resources/assignments/en/chemvlab/thermodynamics/Cobalt2/spectra.json": 42348,
	"resources/assignments/en/chemvlab/thermodynamics/Hotcold1/assignment.json": 69568,
	"resources/assignments/en/chemvlab/thermodynamics/Hotcold1/configuration.json": 57301,
	"resources/assignments/en/chemvlab/thermodynamics/Hotcold1/reactions.json": 64755,
	"resources/assignments/en/chemvlab/thermodynamics/Hotcold1/solutions.json": 85303,
	"resources/assignments/en/chemvlab/thermodynamics/Hotcold1/species.json": 16149,
	"resources/assignments/en/chemvlab/thermodynamics/Hotcold1/spectra.json": 87647,
	"resources/assignments/en/chemvlab/thermodynamics/Hotcold2/assignment.json": 66287,
	"resources/assignments/en/chemvlab/thermodynamics/Hotcold2/configuration.json": 16928,
	"resources/assignments/en/chemvlab/thermodynamics/Hotcold2/reactions.json": 30982,
	"resources/assignments/en/chemvlab/thermodynamics/Hotcold2/solutions.json": 63722,
	"resources/assignments/en/chemvlab/thermodynamics/Hotcold2/species.json": 78640,
	"resources/assignments/en/chemvlab/thermodynamics/Hotcold2/spectra.json": 94290,
	"resources/assignments/en/chemvlab/thermodynamics/Solar1/assignment.json": 24052,
	"resources/assignments/en/chemvlab/thermodynamics/Solar1/configuration.json": 14657,
	"resources/assignments/en/chemvlab/thermodynamics/Solar1/reactions.json": 64575,
	"resources/assignments/en/chemvlab/thermodynamics/Solar1/solutions.json": 61539,
	"resources/assignments/en/chemvlab/thermodynamics/Solar1/species.json": 39633,
	"resources/assignments/en/chemvlab/thermodynamics/Solar1/spectra.json": 65691,
	"resources/assignments/en/chemvlab/thermodynamics/Solar2/assignment.json": 43587,
	"resources/assignments/en/chemvlab/thermodynamics/Solar2/configuration.json": 55948,
	"resources/assignments/en/chemvlab/thermodynamics/Solar2/reactions.json": 12322,
	"resources/assignments/en/chemvlab/thermodynamics/Solar2/solutions.json": 84854,
	"resources/assignments/en/chemvlab/thermodynamics/Solar2/species.json": 74988,
	"resources/assignments/en/chemvlab/thermodynamics/Solar2/spectra.json": 29790,
	"resources/assignments/en/chemvlab/thermodynamics/Swim1/assignment.json": 79321,
	"resources/assignments/en/chemvlab/thermodynamics/Swim1/configuration.json": 86594,
	"resources/assignments/en/chemvlab/thermodynamics/Swim1/reactions.json": 77172,
	"resources/assignments/en/chemvlab/thermodynamics/Swim1/solutions.json": 1768,
	"resources/assignments/en/chemvlab/thermodynamics/Swim1/species.json": 80742,
	"resources/assignments/en/chemvlab/thermodynamics/Swim1/spectra.json": 73272,
	"resources/assignments/en/chemvlab/thermodynamics/Swim2/assignment.json": 87750,
	"resources/assignments/en/chemvlab/thermodynamics/Swim2/configuration.json": 65371,
	"resources/assignments/en/chemvlab/thermodynamics/Swim2/reactions.json": 68413,
	"resources/assignments/en/chemvlab/thermodynamics/Swim2/solutions.json": 82553,
	"resources/assignments/en/chemvlab/thermodynamics/Swim2/species.json": 96487,
	"resources/assignments/en/chemvlab/thermodynamics/Swim2/spectra.json": 28529,
	"resources/assignments/en/chemvlab/thermodynamics/Swim3/assignment.json": 46311,
	"resources/assignments/en/chemvlab/thermodynamics/Swim3/configuration.json": 80680,
	"resources/assignments/en/chemvlab/thermodynamics/Swim3/reactions.json": 84190,
	"resources/assignments/en/chemvlab/thermodynamics/Swim3/solutions.json": 22946,
	"resources/assignments/en/chemvlab/thermodynamics/Swim3/species.json": 3048,
	"resources/assignments/en/chemvlab/thermodynamics/Swim3/spectra.json": 42522,
	"resources/assignments/en/chemvlab/thermodynamics/Swim4/assignment.json": 75524,
	"resources/assignments/en/chemvlab/thermodynamics/Swim4/configuration.json": 53105,
	"resources/assignments/en/chemvlab/thermodynamics/Swim4/reactions.json": 61871,
	"resources/assignments/en/chemvlab/thermodynamics/Swim4/solutions.json": 8371,
	"resources/assignments/en/chemvlab/thermodynamics/Swim4/species.json": 7777,
	"resources/assignments/en/chemvlab/thermodynamics/Swim4/spectra.json": 16907,
	"resources/assignments/en/chemvlab/thermodynamics/Swim5/assignment.json": 17557,
	"resources/assignments/en/chemvlab/thermodynamics/Swim5/configuration.json": 50470,
	"resources/assignments/en/chemvlab/thermodynamics/Swim5/reactions.json": 7304,
	"resources/assignments/en/chemvlab/thermodynamics/Swim5/solutions.json": 96380,
	"resources/assignments/en/chemvlab/thermodynamics/Swim5/species.json": 97322,
	"resources/assignments/en/chemvlab/thermodynamics/Swim5/spectra.json": 80252,
	"resources/assignments/en/chemvlab/thermodynamics/Swim6/assignment.json": 42754,
	"resources/assignments/en/chemvlab/thermodynamics/Swim6/configuration.json": 61583,
	"resources/assignments/en/chemvlab/thermodynamics/Swim6/reactions.json": 89825,
	"resources/assignments/en/chemvlab/thermodynamics/Swim6/solutions.json": 70605,
	"resources/assignments/en/chemvlab/thermodynamics/Swim6/species.json": 49723,
	"resources/assignments/en/chemvlab/thermodynamics/Swim6/spectra.json": 81445,
	"resources/assignments/en/chemvlab/thermodynamics/Swim7/assignment.json": 57299,
	"resources/assignments/en/chemvlab/thermodynamics/Swim7/configuration.json": 37852,
	"resources/assignments/en/chemvlab/thermodynamics/Swim7/reactions.json": 1298,
	"resources/assignments/en/chemvlab/thermodynamics/Swim7/solutions.json": 79014,
	"resources/assignments/en/chemvlab/thermodynamics/Swim7/species.json": 74300,
	"resources/assignments/en/chemvlab/thermodynamics/Swim7/spectra.json": 28174,
	"resources/assignments/en/chemvlab/thermodynamics/Thiocyanate/assignment.json": 98687,
	"resources/assignments/en/chemvlab/thermodynamics/Thiocyanate/configuration.json": 76208,
	"resources/assignments/en/chemvlab/thermodynamics/Thiocyanate/reactions.json": 87638,
	"resources/assignments/en/chemvlab/thermodynamics/Thiocyanate/solutions.json": 13658,
	"resources/assignments/en/chemvlab/thermodynamics/Thiocyanate/species.json": 45472,
	"resources/assignments/en/chemvlab/thermodynamics/Thiocyanate/spectra.json": 80610,
	"resources/assignments/en/colligative/bp_elevation/assignment.json": 12657,
	"resources/assignments/en/colligative/bp_elevation/configuration.json": 18282,
	"resources/assignments/en/colligative/bp_elevation/reactions.json": 34700,
	"resources/assignments/en/colligative/bp_elevation/solutions.json": 8544,
	"resources/assignments/en/colligative/bp_elevation/species.json": 7294,
	"resources/assignments/en/colligative/bp_elevation/spectra.json": 37184,
	"resources/assignments/en/colligative/solution_nonaq/assignment.json": 7804,
	"resources/assignments/en/colligative/solution_nonaq/configuration.json": 13273,
	"resources/assignments/en/colligative/solution_nonaq/reactions.json": 88615,
	"resources/assignments/en/colligative/solution_nonaq/solutions.json": 41035,
	"resources/assignments/en/colligative/solution_nonaq/species.json": 43417,
	"resources/assignments/en/colligative/solution_nonaq/spectra.json": 93235,
	"resources/assignments/en/colligative/vapor_pressure/assignment.json": 54811,
	"resources/assignments/en/colligative/vapor_pressure/configuration.json": 98004,
	"resources/assignments/en/colligative/vapor_pressure/reactions.json": 5018,
	"resources/assignments/en/colligative/vapor_pressure/solutions.json": 16814,
	"resources/assignments/en/colligative/vapor_pressure/species.json": 41892,
	"resources/assignments/en/colligative/vapor_pressure/spectra.json": 2329,
	"resources/assignments/en/default/assignment.json": 41826,
	"resources/assignments/en/default/configuration.json": 20271,
	"resources/assignments/en/default/reactions.json": 15297,
	"resources/assignments/en/default/solutions.json": 74029,
	"resources/assignments/en/default/species.json": 57339,
	"resources/assignments/en/default/spectra.json": 57093,
	"resources/assignments/en/hotcoldpack/assignment.json": 2561,
	"resources/assignments/en/hotcoldpack/configuration.json": 2042,
	"resources/assignments/en/hotcoldpack/reactions.json": 34940,
	"resources/assignments/en/hotcoldpack/solutions.json": 24528,
	"resources/assignments/en/hotcoldpack/species.json": 69486,
	"resources/assignments/en/hotcoldpack/spectra.json": 11632,
	"resources/assignments/en/iron_thiocyanate/assignment.json": 16835,
	"resources/assignments/en/iron_thiocyanate/configuration.json": 27436,
	"resources/assignments/en/iron_thiocyanate/reactions.json": 52866,
	"resources/assignments/en/iron_thiocyanate/solutions.json": 31254,
	"resources/assignments/en/iron_thiocyanate/species.json": 49868,
	"resources/assignments/en/iron_thiocyanate/spectra.json": 42366,
	"resources/assignments/en/kinetics/cv_bleaching/assignment.json": 23811,
	"resources/assignments/en/kinetics/cv_bleaching/configuration.json": 18892,
	"resources/assignments/en/kinetics/cv_bleaching/reactions.json": 46658,
	"resources/assignments/en/kinetics/cv_bleaching/solutions.json": 2838,
	"resources/assignments/en/kinetics/cv_bleaching/species.json": 32460,
	"resources/assignments/en/kinetics/cv_bleaching/spectra.json": 87262,
	"resources/assignments/en/kinetics/iodide_persulfate/assignment.json": 28380,
	"resources/assignments/en/kinetics/iodide_persulfate/configuration.json": 37017,
	"resources/assignments/en/kinetics/iodide_persulfate/reactions.json": 45191,
	"resources/assignments/en/kinetics/iodide_persulfate/solutions.json": 75307,
	"resources/assignments/en/kinetics/iodide_persulfate/species.json": 95705,
	"resources/assignments/en/kinetics/iodide_persulfate/spectra.json": 18803,
	"resources/assignments/en/kinetics/k1/assignment.json": 78182,
	"resources/assignments/en/kinetics/k1/configuration.json": 29531,
	"resources/assignments/en/kinetics/k1/reactions.json": 92861,
	"resources/assignments/en/kinetics/k1/solutions.json": 44057,
	"resources/assignments/en/kinetics/k1/species.json": 48199,
	"resources/assignments/en/kinetics/k1/spectra.json": 15409,
	"resources/assignments/en/kinetics/k2/assignment.json": 64121,
	"resources/assignments/en/kinetics/k2/configuration.json": 4770,
	"resources/assignments/en/kinetics/k2/reactions.json": 5172,
	"resources/assignments/en/kinetics/k2/solutions.json": 7240,
	"resources/assignments/en/kinetics/k2/species.json": 68806,
	"resources/assignments/en/kinetics/k2/spectra.json": 70392,
	"resources/assignments/en/kinetics/k3/assignment.json": 79640,
	"resources/assignments/en/kinetics/k3/configuration.json": 82717,
	"resources/assignments/en/kinetics/k3/reactions.json": 51371,
	"resources/assignments/en/kinetics/k3/solutions.json": 15439,
	"resources/assignments/en/kinetics/k3/species.json": 64685,
	"resources/assignments/en/kinetics/k3/spectra.json": 83495,
	"resources/assignments/en/kinetics/k4equilibrium/assignment.json": 92013,
	"resources/assignments/en/kinetics/k4equilibrium/configuration.json": 9070,
	"resources/assignments/en/kinetics/k4equilibrium/reactions.json": 45600,
	"resources/assignments/en/kinetics/k4equilibrium/solutions.json": 14228,
	"resources/assignments/en/kinetics/k4equilibrium/species.json": 93954,
	"resources/assignments/en/kinetics/k4equilibrium/spectra.json": 76228,
	"resources/assignments/en/kinetics/k5/assignment.json": 35106,
	"resources/assignments/en/kinetics/k5/configuration.json": 1935,
	"resources/assignments/en/kinetics/k5/reactions.json": 67041,
	"resources/assignments/en/kinetics/k5/solutions.json": 26925,
	"resources/assignments/en/kinetics/k5/species.json": 79867,
	"resources/assignments/en/kinetics/k5/spectra.json": 68229,
	"resources/assignments/en/metals/assignment.json": 12455,
	"resources/assignments/en/metals/configuration.json": 29128,
	"resources/assignments/en/metals/reactions.json": 58174,
	"resources/assignments/en/metals/solutions.json": 90946,
	"resources/assignments/en/metals/species.json": 10760,
	"resources/assignments/en/metals/spectra.json": 16602,
	"resources/assignments/en/oracle-1/assignment.json": 12711,
	"resources/assignments/en/oracle-1/configuration.json": 82600,
	"resources/assignments/en/oracle-1/reactions.json": 5918,
	"resources/assignments/en/oracle-1/solutions.json": 49506,
	"resources/assignments/en/oracle-1/species.json": 30088,
	"resources/assignments/en/oracle-1/spectra.json": 52762,
	"resources/assignments/en/oracle-2/assignment.json": 92792,
	"resources/assignments/en/oracle-2/configuration.json": 31581,
	"resources/assignments/en/oracle-2/reactions.json": 40587,
	"resources/assignments/en/oracle-2/solutions.json": 4655,
	"resources/assignments/en/oracle-2/species.json": 85773,
	"resources/assignments/en/oracle-2/spectra.json": 4583,
	"resources/assignments/en/oracle-2_2/assignment.json": 50139,
	"resources/assignments/en/oracle-2_2/configuration.json": 564,
	"resources/assignments/en/oracle-2_2/reactions.json": 66170,
	"resources/assignments/en/oracle-2_2/solutions.json": 48430,
	"resources/assignments/en/oracle-2_2/species.json": 27236,
	"resources/assignments/en/oracle-2_2/spectra.json": 2086,
	"resources/assignments/en/oracle-3/assignment.json": 77273,
	"resources/assignments/en/oracle-3/configuration.json": 53634,
	"resources/assignments/en/oracle-3/reactions.json": 94388,
	"resources/assignments/en/oracle-3/solutions.json": 96456,
	"resources/assignments/en/oracle-3/species.json": 89894,
	"resources/assignments/en/oracle-3/spectra.json": 91480,
	"resources/assignments/en/oracle-3_2/assignment.json": 54674,
	"resources/assignments/en/oracle-3_2/configuration.json": 13759,
	"resources/assignments/en/oracle-3_2/reactions.json": 9009,
	"resources/assignments/en/oracle-3_2/solutions.json": 35837,
	"resources/assignments/en/oracle-3_2/species.json": 45387,
	"resources/assignments/en/oracle-3_2/spectra.json": 76981,
	"resources/assignments/en/oracle-4/assignment.json": 48258,
	"resources/assignments/en/oracle-4/configuration.json": 50799,
	"resources/assignments/en/oracle-4/reactions.json": 56257,
	"resources/assignments/en/oracle-4/solutions.json": 16141,
	"resources/assignments/en/oracle-4/species.json": 955,
	"resources/assignments/en/oracle-4/spectra.json": 72965,
	"resources/assignments/en/oracle-temp-1/assignment.json": 42314,
	"resources/assignments/en/oracle-temp-1/configuration.json": 60679,
	"resources/assignments/en/oracle-temp-1/reactions.json": 58921,
	"resources/assignments/en/oracle-temp-1/solutions.json": 78677,
	"resources/assignments/en/oracle-temp-1/species.json": 87651,
	"resources/assignments/en/oracle-temp-1/spectra.json": 48317,
	"resources/assignments/en/oracle-temp-2/assignment.json": 73821,
	"resources/assignments/en/oracle-temp-2/configuration.json": 59710,
	"resources/assignments/en/oracle-temp-2/reactions.json": 91024,
	"resources/assignments/en/oracle-temp-2/solutions.json": 52708,
	"resources/assignments/en/oracle-temp-2/species.json": 42386,
	"resources/assignments/en/oracle-temp-2/spectra.json": 77268,
	"resources/assignments/en/oracle-temp-2b/assignment.json": 96253,
	"resources/assignments/en/oracle-temp-2b/configuration.json": 36990,
	"resources/assignments/en/oracle-temp-2b/reactions.json": 44688,
	"resources/assignments/en/oracle-temp-2b/solutions.json": 57508,
	"resources/assignments/en/oracle-temp-2b/species.json": 63538,
	"resources/assignments/en/oracle-temp-2b/spectra.json": 18580,
	"resources/assignments/en/oracle-temp-3/assignment.json": 59148,
	"resources/assignments/en/oracle-temp-3/configuration.json": 18569,
	"resources/assignments/en/oracle-temp-3/reactions.json": 54711,
	"resources/assignments/en/oracle-temp-3/solutions.json": 99227,
	"resources/assignments/en/oracle-temp-3/species.json": 96521,
	"resources/assignments/en/oracle-temp-3/spectra.json": 34051,
	"resources/assignments/en/oracle-temp-3b/assignment.json": 55290,
	"resources/assignments/en/oracle-temp-3b/configuration.json": 29015,
	"resources/assignments/en/oracle-temp-3b/reactions.json": 74649,
	"resources/assignments/en/oracle-temp-3b/solutions.json": 99333,
	"resources/assignments/en/oracle-temp-3b/species.json": 33587,
	"resources/assignments/en/oracle-temp-3b/spectra.json": 7277,
	"resources/assignments/en/oracle-temp-4/assignment.json": 3023,
	"resources/assignments/en/oracle-temp-4/configuration.json": 68096,
	"resources/assignments/en/oracle-temp-4/reactions.json": 56102,
	"resources/assignments/en/oracle-temp-4/solutions.json": 71018,
	"resources/assignments/en/oracle-temp-4/species.json": 82576,
	"resources/assignments/en/oracle-temp-4/spectra.json": 9618,
	"resources/assignments/en/solids/solubility/assignment.json": 60322,
	"resources/assignments/en/solids/solubility/configuration.json": 14895,
	"resources/assignments/en/solids/solubility/reactions.json": 27489,
	"resources/assignments/en/solids/solubility/solutions.json": 8269,
	"resources/assignments/en/solids/solubility/species.json": 19387,
	"resources/assignments/en/solids/solubility/spectra.json": 51109,
	"resources/assignments/en/solids/solubilityLargeHeat/assignment.json": 18617,
	"resources/assignments/en/solids/solubilityLargeHeat/configuration.json": 68674,
	"resources/assignments/en/solids/solubilityLargeHeat/reactions.json": 63444,
	"resources/assignments/en/solids/solubilityLargeHeat/solutions.json": 88040,
	"resources/assignments/en/solids/solubilityLargeHeat/species.json": 48294,
	"resources/assignments/en/solids/solubilityLargeHeat/spectra.json": 24472,
	"resources/assignments/en/solubility/assignment.json": 79171,
	"resources/assignments/en/solubility/configuration.json": 88300,
	"resources/assignments/en/solubility/reactions.json": 60354,
	"resources/assignments/en/solubility/solutions.json": 38742,
	"resources/assignments/en/solubility/species.json": 70124,
	"resources/assignments/en/solubility/spectra.json": 78974,
	"resources/assignments/en/study/assignment.json": 73618,
	"resources/assignments/en/study/configuration.json": 26975,
	"resources/assignments/en/study/reactions.json": 26705,
	"resources/assignments/en/study/solutions.json": 53533,
	"resources/assignments/en/study/species.json": 38155,
	"resources/assignments/en/study/spectra.json": 69749,
	"resources/assignments/en/test/assignment.json": 78383,
	"resources/assignments/en/test/configuration.json": 45760,
	"resources/assignments/en/test/reactions.json": 9350,
	"resources/assignments/en/test/solutions.json": 35594,
	"resources/assignments/en/test/species.json": 82032,
	"resources/assignments/en/test/spectra.json": 19698,
	"resources/assignments/es/default/assignment.json": 58407,
	"resources/assignments/es/default/configuration.json": 87496,
	"resources/assignments/es/default/reactions.json": 40894,
	"resources/assignments/es/default/solutions.json": 79650,
	"resources/assignments/es/default/species.json": 36072,
	"resources/assignments/es/default/spectra.json": 75546,
	"resources/assignments_chemv_en.json": 19806,
	"resources/assignments_en.json": 69788,
	"resources/assignments_es.json": 299
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4629;